import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
type ButtonLinkProps = {
  href: string;
  children: React.ReactNode;
  variant?: 'solid' | 'text';
  className?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
};

/** Shared primary and secondary action treatment for the portfolio. */
export function ButtonLink({
  href,
  children,
  variant = 'solid',
  className = '',
  onClick
}: ButtonLinkProps) {
  if (variant === 'text') {
    return <a href={href} onClick={onClick} className={`group inline-flex items-center gap-2 font-display text-base font-medium uppercase tracking-[0.08em] text-foreground transition-colors duration-200 hover:text-cobalt focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cobalt focus-visible:ring-offset-4 ${className}`} data-id="element-66" data-mp="5pe9ivrag9bb">
        {children}
        <ArrowUpRightIcon aria-hidden="true" size={16} className="transition-transform duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-67" data-mp="2hikx00zesf9j" />
      </a>;
  }
  return <a href={href} onClick={onClick} className={`group inline-flex items-center gap-3 bg-foreground px-5 py-3 font-display text-base font-medium uppercase tracking-[0.08em] text-background transition-colors duration-200 hover:bg-cobalt focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cobalt focus-visible:ring-offset-4 ${className}`} data-id="element-68" data-mp="ehc1erxker8w">
      {children}
      <ArrowUpRightIcon aria-hidden="true" size={16} className="transition-transform duration-200 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-69" data-mp="3rnvognc26bm8" />
    </a>;
}